import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import NavBar from "./NavBar";
import PageHeader from "./PageHeader";
import {routesConfig} from "./route";

const drawerWidth = 240;

export default function Layout({locale, setLocale, backgroundColor = "#f5f5f5"}) {
  const isMobile = useMediaQuery("(max-width: 900px)");
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile); // Open on desktop, closed on mobile
  const location = useLocation();
  const currentRoute = routesConfig.find(route => location.pathname.startsWith(route.path));
  const pageTitle = currentRoute ? currentRoute.title : "Dashboard"; // Default title

  return (
    <Box sx={{ display: "flex", width: "100vw", height: "100vh" }}>
      <NavBar isOpen={sidebarOpen} toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: isMobile ? "100%" : sidebarOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
          pt: "64px",
          transition: "width 0.3s ease-in-out",
        }}
      >
        <PageHeader
          title={pageTitle}
          locale={locale}
          setLocale = {setLocale}
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          sidebarOpen={sidebarOpen}
        />
        <Outlet context={{ backgroundColor }}/>
      </Box>
    </Box>
  );
}
